const baseFormat = '#,##0';

export default ({
  percentage,
  hideDecimals,
  negativeMinus,
  shouldDisplayZero,
  numberOfDecimalPlaces = 4,
}) => {
  const format = `${baseFormat}${hideDecimals || percentage ? '' : '.00'}${percentage ? `.${new Array(numberOfDecimalPlaces).fill('0').join('')}%` : ''}`;
  const negativeFormat = negativeMinus ? `-${format}` : `(${format})`;
  return `${format};${negativeFormat}${shouldDisplayZero ? '' : ';-;@'}`;
};
